import React, { useEffect, useState } from 'react';
import { toast } from 'sonner';
import api from '../../utils/axios';
import { Button } from '../ui/button';
import { Textarea } from '../ui/textarea';
import {
  Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle,
} from '../ui/dialog';

const TITULOS = { DESCARTAR: 'Descartar episodio', REVISADO: 'Marcar episodio como revisado', ESCALAR: 'Escalar episodio' };

// G4: descartar o cerrar exige motivo de lista cerrada y propone una conclusión editable. Escalar pide un comentario.
export const EpisodioAccionDialog = ({ caseId, episodio, accion, motivos, onClose, onCambio }) => {
  const [motivo, setMotivo] = useState('');
  const [motivoTexto, setMotivoTexto] = useState('');
  const [conclusion, setConclusion] = useState('');
  const [guardando, setGuardando] = useState(false);
  const esCierre = accion === 'DESCARTAR' || accion === 'REVISADO';

  useEffect(() => { setMotivo(''); setMotivoTexto(''); setConclusion(''); }, [accion, episodio?.id]);
  useEffect(() => {
    if (!esCierre || !motivo) return;
    api.get(`/cases/${caseId}/episodios/${episodio.id}/conclusion-sugerida`, { params: { motivo, texto: motivoTexto } })
      .then((r) => setConclusion(r.data.conclusion || '')).catch(() => {});
  }, [motivo]); // eslint-disable-line react-hooks/exhaustive-deps

  const valido = esCierre ? motivo && (motivo !== 'OTRO' || motivoTexto.trim()) && conclusion.trim() : conclusion.trim();
  const confirmar = async () => {
    setGuardando(true);
    try {
      if (esCierre) {
        await api.post(`/cases/${caseId}/episodios/${episodio.id}/cerrar`, { accion, motivo, motivo_texto: motivoTexto, conclusion });
        toast.success(accion === 'DESCARTAR' ? 'Episodio descartado' : 'Episodio marcado como revisado');
      } else {
        await api.post(`/cases/${caseId}/alertas/${episodio.id}/notas`, { alerta_id: episodio.id, comentario: conclusion.trim(), tipo: 'ESCALAR' });
        toast.success('Episodio escalado');
      }
      onClose();
      onCambio();
    } catch (e) {
      toast.error(e.response?.data?.detail || 'No se pudo guardar');
    } finally { setGuardando(false); }
  };

  return (
    <Dialog open={!!accion} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-lg bg-white" data-testid="episodio-accion-dialog">
        <DialogHeader>
          <DialogTitle>{TITULOS[accion]}</DialogTitle>
          <DialogDescription>{episodio?.monitor} · {episodio?.cantidad} movimientos</DialogDescription>
        </DialogHeader>
        <div className="space-y-4">
          {esCierre && (
            <div>
              <p className="mb-2 text-xs font-semibold uppercase tracking-wide text-slate-500">Motivo</p>
              <div className="grid grid-cols-2 gap-2">
                {Object.entries(motivos).map(([k, v]) => (
                  <button key={k} type="button" onClick={() => setMotivo(k)} data-testid={`episodio-motivo-${k}`}
                    className={`rounded-lg border px-3 py-2 text-left text-sm transition-colors ${motivo === k ? 'border-sky-500 bg-sky-50 font-medium text-sky-800' : 'border-slate-200 hover:bg-slate-50'}`}>
                    {v}
                  </button>
                ))}
              </div>
              {motivo === 'OTRO' && (
                <input value={motivoTexto} onChange={(e) => setMotivoTexto(e.target.value)} placeholder="Detalle del motivo"
                  data-testid="episodio-motivo-texto" className="mt-2 h-9 w-full rounded-md border border-slate-200 px-3 text-sm" />
              )}
            </div>
          )}
          <div>
            <p className="mb-2 text-xs font-semibold uppercase tracking-wide text-slate-500">{esCierre ? 'Conclusión (editable)' : 'Motivo del escalamiento'}</p>
            <Textarea rows={4} value={conclusion} onChange={(e) => setConclusion(e.target.value)} data-testid="episodio-conclusion"
              placeholder={esCierre ? 'Elegí un motivo para proponer la conclusión' : 'Por qué se escala este episodio'} />
          </div>
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={onClose}>Cancelar</Button>
          <Button onClick={confirmar} disabled={!valido || guardando} data-testid="episodio-accion-confirmar"
            className={accion === 'DESCARTAR' ? 'bg-zinc-700 hover:bg-zinc-800' : accion === 'ESCALAR' ? 'bg-orange-600 hover:bg-orange-700' : 'bg-emerald-600 hover:bg-emerald-700'}>
            {guardando ? 'Guardando…' : 'Confirmar'}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default EpisodioAccionDialog;
